module.exports = __webpack_public_path__ + "img/IchHasseDiesenWald.af18f7eb.svg";